import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const BORDER_WIDTH = 5;

const SliderListFocus = styled.div<React.CSSProperties>`
  border: ${BORDER_WIDTH * Screen.widthRatio}px solid white;
  border-radius: ${36 * Screen.widthRatio}px;
  cursor: pointer;
  height: ${428 * Screen.widthRatio}px;
  position: absolute;
  width: ${760 * Screen.widthRatio}px;
`;

export default SliderListFocus;
